import * as React from 'react';

import { CompanyLabel } from '../CompanyLabel';
import * as styles from './CianContacts.css';

interface ICianContactsProps extends React.PropsWithChildren {
  withButtonsGap?: boolean;
}

export const CianContacts: React.FC<ICianContactsProps> = ({ children, withButtonsGap = false }) => {
  // TODO: В CD-199910 удалить игнор: будет удалено свойство withButtonsGap, и покрытия хватит
  // istanbul ignore next
  return (
    <div className={styles['container']}>
      <CompanyLabel>КОНСУЛЬТАНТ</CompanyLabel>
      <div className={styles['info']}>
        <strong className={styles['title']}>Циан</strong>
        <p className={styles['description']}>Основан в 2001 году</p>
      </div>
      {withButtonsGap ? <div className={styles['buttons']}>{children}</div> : children}
    </div>
  );
};

CianContacts.displayName = 'CianContacts';
